// extracted by mini-css-extract-plugin
export default {"aboutDiv":"AboutUs_aboutDiv__-sKIM"};